import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthorizationSelectors } from '@next/core-lib/authorization';
import { UserSelectors, UserState } from '@next/core-lib/user';
import { Store } from '@ngrx/store';
import { combineLatest, filter, map, take } from 'rxjs';

@Injectable()
export class TgaAccessGuard {
  private readonly store = inject<Store<UserState>>(Store);
  private readonly router = inject(Router);

  canActivate(_: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    return combineLatest([
      this.store.select(UserSelectors.selectUserInitialized),
      this.store.select(AuthorizationSelectors.hasAtLeastCustomerRoleForApplicationKey('TGACA')),
    ]).pipe(
      filter(([userInitialized, hasRole]) => userInitialized !== undefined && hasRole !== undefined),
      take(1),
      map(([_userInitialized, hasRole]) => (hasRole ? true : this.router.createUrlTree(['/']))),
    );
  }
}
